var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRingNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 56.5391L74.9688 56.5391C76.3032 56.5391 77.5829 57.0691 78.5264 58.0126C79.47 58.9562 80 60.2359 80 61.5703C79.9984 62.9042 79.4679 64.183 78.5247 65.1262C77.5815 66.0694 76.3027 66.5999 74.9688 66.6015H27.0312C25.6968 66.6015 24.4173 66.0715 23.4737 65.1279C22.5302 64.1844 22 62.9046 22 61.5703C21.9992 60.9093 22.1288 60.2547 22.3814 59.6439C22.6339 59.0332 23.0045 58.4782 23.4718 58.0109C23.9392 57.5435 24.4942 57.173 25.105 56.9204C25.7158 56.6679 26.3703 56.5383 27.0312 56.5391H31.3028",
    stroke: "#666666",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4825 66.0693C62.6211 68.7069 60.9481 71.0048 58.7025 72.6347C56.457 74.2646 53.7538 75.1431 50.9791 75.1447C48.2231 75.1426 45.5373 74.2754 43.3005 72.6654C41.0636 71.0554 39.3886 68.7838 38.5117 66.171",
    stroke: "#666666",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6016 26.7166V24.3952C44.6031 22.6996 45.2775 21.0741 46.4765 19.8751C47.6755 18.6761 49.3011 18.0016 50.9968 18C52.6924 18.0016 54.3182 18.6761 55.5172 19.8751C56.7162 21.0741 57.3904 22.6996 57.392 24.3952V25.861",
    stroke: "#666666",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9854 57.1313V45.3279C30.9869 40.021 33.0958 34.9319 36.8483 31.1794C40.6009 27.4269 45.6898 25.318 50.9967 25.3164C56.3035 25.318 61.3926 27.4269 65.1452 31.1794C68.8977 34.9319 71.0064 40.021 71.008 45.3279V57.1313",
    stroke: "#666666",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3027 56.5332H46.57",
    stroke: "#666666",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4385 56.5332H56.2194",
    stroke: "#666666",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingNotification);
export default __webpack_public_path__ + "static/media/ring-notification.9d4e4af6881e09437bf8a9d53815dcb5.svg";
export { ForwardRef as ReactComponent };